import React, {PropsWithChildren} from 'react';
import {StyleSheet, View, StyleProp, ViewStyle} from 'react-native';

export type ContainerProps = {
  style?: StyleProp<ViewStyle>;
  loading?: boolean;
};

export const Container: React.FC<PropsWithChildren<ContainerProps>> = ({
  style,
  loading,
  children,
}) => {
  return (
    <View style={[styles.container, style]}>
      {children}
      {loading ? <View style={styles.loadingOverlay} /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loadingOverlay: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
});
